import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {inject} from "@angular/core";
import {filter, take, withLatestFrom} from "rxjs";
import {map} from "rxjs/operators";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

export const linkKnowledgeResolver: ResolveFn<{ isBackButtonEnable: boolean }> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const store: Store = inject(Store);
    let isBackButtonEnable: boolean = route.data['isBackButtonEnable'];

    return store.pipe(
      withLatestFrom(store.pipe(select(SharedLoginSelectors.selectIsLoading))),
      withLatestFrom(store.pipe(select(SharedLoginSelectors.selectLinkFeatures))),
      filter(([[_, loading], features]) => !!features && !loading),
      take(1),
      map(([_, features]) => {
        isBackButtonEnable = features?.isKnowledgeVisible!
        return ({ isBackButtonEnable })
      })
    );
  };
